import Crud from '../views/CompanionType/Crud'
import Entity from '../views/CompanionType/Add'

let routes = {
    path: '/companion_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/companion_types/add',
            name: 'NewCompanionType',
            component: Entity,
            meta: {
                pageTitle: 'Tipo de Acompanhante',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Adicionar Acompanhante',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/companion_types/edit/:id?',
            name: 'EditCompanionType',
            component: Entity,
            meta: {
                pageTitle: 'Tipo de Acompanhante',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Editar Tipo de Acompanhante',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/companion_types',
            name: 'list-companion-types',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipos de Acompanhantes',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Tipos de Acompanhantes',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
